import React from "react";
import { Typography } from "design_system/src";
import HelperCardImg from "../../static/helperCard/helperCardImg.png";

type HelperCardProps = {
  triggerCard: any;
  isHovering: boolean;
  isMobile: boolean;
};


const HelperCard: React.FC<HelperCardProps> = ({
  triggerCard,
  isHovering,
  isMobile,
}) => {
  const handleCardClick = () => triggerCard();

  return isMobile ? (
    <div
      className="display_flex"
      onClick={handleCardClick}
      style={{
        flexDirection: "column",
        justifyContent: "start",
        padding: 10,
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "start",
        }}
      >
        <img
          src={HelperCardImg}
          alt="thumbnail"
          style={{
            maxHeight: "80px",
            minWidth: "124px",
            height: "auto",
            width: "35%",
            marginLeft: "10px",
            marginRight: "25px",
            borderRadius: 10,
            marginBottom: 20,
          }}
        />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "start",
            alignItems: "start",
          }}
        >
          <Typography
            scale="large"
            weight="400"
            className="text_neutral_800 "
          >
            <span className="text_primary_300">¿Te ayudamos</span> a encontrar{" "}
            <span className="text_neutral_900">tu moto personalizada?</span>
          </Typography>
        </div>
      </div>
      <div style={{ borderBottom: "0.529801px solid #DEDEDE" }} />
      <div
        className="m_t_xs flex_gap_sm"
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-evenly",
        }}
      >
        <div>
          <div className="display_flex" style={{ flexDirection: "column" }}>
            <div className="w_100_per bg_neutral_300 br_xs display_flex flex_center m_b_md">
              <Typography
                scale="xsmall"
                weight="600"
                className="text_neutral_800 text_center "
                style={{
                  width: "100%",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  padding: "5px 10px",
                }}
              >
                De manera fácil y rápida
              </Typography>
            </div>
            <div className="w_100_per bg_neutral_300 br_xs display_flex flex_center">
              <Typography
                scale="xsmall"
                weight="600"
                className="text_neutral_800 text_center"
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  padding: "5px 10px",
                }}
              >
                Sin dar enganche
              </Typography>
            </div>
          </div>
        </div>
        <div className="p_md flex_center w_60_per br_sm bg_primary_50">
          <Typography
            scale="large"
            weight="600"
            className="text_primary_300 text-center"
          >
            ¡Haz la prueba!
          </Typography>
        </div>
      </div>
    </div>
  ) : (
    <div style={{ padding: 10, height: "100%", display: "flex", flexDirection: "column" }} onClick={handleCardClick}>
      <div className="image-box">
        <img
          height="180"
          className=" br_xs  card_media_helper"
          src={HelperCardImg}
          alt="helper"
        />
      </div>

      <div>
        <Typography
          scale="medium"
          weight="600"
          className="text_neutral_800 m_y_xs"
        >
          <span className="text_primary_300">¿Te ayudamos</span>{" "}
          <span style={{ fontWeight: "normal" }}>a encontrar</span> tu moto
          ideal?
        </Typography>
      </div>

      <div>
        <div className="display_flex flex_gap_xs w_100_per m_b_xs">
          <div className="w_100_per bg_neutral_300 br_xs display_flex flex_center">
            <Typography
              scale="xsmall"
              weight="600"
              className="text_neutral_800 text_center p_y_xs"
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              Sin dar enganche
            </Typography>
          </div>
        </div>
        <div className="display_flex flex_gap_xs w_100_per">
          <div className="w_100_per bg_neutral_300 br_xs display_flex flex_center">
            <Typography
              scale="xsmall"
              weight="600"
              className="text_neutral_800 text_center p_y_xs"
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              De manera fácil y rápida
            </Typography>
          </div>
        </div>
      </div>

      <div
        className="br_b_xs m_t_xs w_100_per"
        style={{
          backgroundColor: isHovering ? "#FDE9D3" : "#ecedef",
          flexGrow: 1
        }}
      >
        <Typography scale="medium" weight="400" className="text_center p_md">
          Si no estás seguro de{" "}
          <span style={{ fontWeight: "bold" }}>qué moto escoger,</span>{" "}
          <span style={{ fontWeight: "bold" }} className="text_primary_300">
            ¡te ayudamos!
          </span>
        </Typography>
      </div>
    </div>
  );
};

export default HelperCard;
